import { AxiosError } from "axios"
import { HttpGetClient } from "../../data/protocols/adapters/HttpGetClient"
import api from "../../services/api"

export class ApiHttpClient implements HttpGetClient {
  async get (params: HttpGetClient.Params): Promise<HttpGetClient.Result> {
    try {
      const response = await api.get(params.url, {
        params: params.data,
        headers: params.headers
      })
      return {
        data: response.data,
        status: response.status
      }
    } catch (error) {
      const err = error as AxiosError
      return {
        data: err.response?.data || err.message,
        status: err.response?.status || 500
      }
    }
  }
}